import React, { useState, useEffect } from "react";
import { useSelector, useDispatch  } from "react-redux";
import { push } from "connected-react-router";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
} from "reactstrap";
import DeleteModal from "../../components/deleteModal";
import { sortArrayOfObjects, getOffer} from "../../utilities/methods";
import { deleteProduct } from "../../redux/actions/product-action-types";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import './product.css';
import { DateTime } from "luxon";
import moment from "moment";
import DataTable from 'react-data-table-component';

const customStyles = {
  headCells: {
    style: {
      paddingLeft: '8px', 
      paddingRight: '8px',
      fontSize:'18px',
      fontWeight:'bold'
    },
  },
};

function Products() {

  /** State Variables */
  const [_products, setProducts] = useState([]),
    [orderby, setOrderBy] = useState("createdAt"),
    [sortby, setSortby] = useState("desc"),
    [shareModal, toggleShareModal] = useState(false),
    [selectedCategory, setSelectedCategory] = useState(null),
    [selectedProduct, setSelectedProduct] = useState(null),
    [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false),
    [isChecked, setIsChecked] = useState(false),
    [allcheckedproduct, setCheckedProduct] = useState([]),
    [shareCode, setSharedCode] = useState(""),
    [columns, setColumns] = useState([]),
    [shareUrl, setShareUrl] = useState(""),
    [pages, setPage] = useState(0),
    [pageLimit] = useState(2),
    [dataLimit]=useState(10)

  /** Redux Variables */
  const products = useSelector((state) => state.product?.products);
  let dispatch = useDispatch();

  /*Pagination logic*/
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (products.length) {
        setPage(Math.round(products.length / dataLimit))
    }
  },[products]);
  /*End pagination logic */

  const productDetail = row => {
    //window.open(`/product-detail/${row.id}`,'_blank');
    //dispatch(push(`/product-detail/${row.id}`));
  }

  const getOffers = row => {
    const data = getOffer('OcgJmbTkVnGCToX36gjB');
    return data;
  }

  useEffect(() => {
    //const offer = getOffers();
    //console.log("Offer", offer);
    if (products.length) {
      let filteredProducts = products.sort(sortArrayOfObjects(orderby, sortby));
      setProducts([...filteredProducts]);
    }
    setColumns([
      {
         name: 'Listing Name',
         selector: row => {
          return <span onClick={()=>{window.open(`/product-detail/${row.id}`, "_blank");}} style={{cursor:"pointer"}}>{row.name}</span>;
        },
         sortable: true
      },
      {
        name: 'Category',
        selector: 'categoryName',
        sortable: true
      },
      {
        name: 'Sub Category',
        selector: 'subCategoryName',
        sortable: true
      },
      {
        name: 'Price',
        selector: 'buyNowPrice',
        cell: row =>{
          return(
               <span>{`$ ${row.buyNowPrice}`}</span>
          )
        },
        sortable: true
      },
      {
        name: 'Minimum Offer Amount',
        selector: 'minimumOfferPrice',
        cell: row =>{
          return(
               <span>{`$ ${row.minimumOfferPrice}`}</span>
          )
        },
        sortable: true
      },
      /*{
        name: 'No Of Offers',
        selector: 'offers',
        cell: row =>{
           
            return(
                 <span>{row.offers?row.offers.length:0}</span>
            )
        },
      },*/
      {
        name: "Status",
        cell: (row) => {
          return (
            <button
              className={`btn 
                    ${
                      row.status.toLowerCase() === "active" ? "listedBtn" : null
                    }
                    ${
                      row.status.toLowerCase() === "unclaimed" ||
                      row.status.toLowerCase() === "listed"
                        ? "listedBtn"
                        : null
                    }
                    ${
                      row.status.toLowerCase() === "bidding"
                        ? "biddingBtn"
                        : null
                    }
                    ${
                      row.status.toLowerCase() === "expired"
                        ? "ExpiredBtn"
                        : null
                    }
                    ${row.status.toLowerCase() === "sold" ? "soldBtn" : null}`}
            >
              {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
            </button>
          );
        },
        selector: "status",
        minWidth: "150px",
      },
      {
        name: 'Seller Info',
        selector: 'sellerEmail',
        sortable: true
      },
      {
         name:'Actions',
         cell: row =>{
              return(
                <div className="dropdown">
                        <UncontrolledDropdown setActiveFromChild>
                          <DropdownToggle tag="a">
                            <button
                              className="btn btn-link p-0"
                              type="button"
                              id="dropdownMenu1"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <svg
                                width="22"
                                height="6"
                                viewBox="0 0 22 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                              </svg>
                            </button>
                          </DropdownToggle>
                          <DropdownMenu className="table-action" right>
                            <DropdownItem onClick={(e) => {
                                   e.preventDefault();
                                   dispatch(push(`/add-new/${row.id}`));
                             }}>
                              {" "}
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.33398 2.66663H2.66732C2.3137 2.66663 1.97456 2.8071 1.72451 3.05715C1.47446 3.3072 1.33398 3.64634 1.33398 3.99996V13.3333C1.33398 13.6869 1.47446 14.0261 1.72451 14.2761C1.97456 14.5262 2.3137 14.6666 2.66732 14.6666H12.0007C12.3543 14.6666 12.6934 14.5262 12.9435 14.2761C13.1935 14.0261 13.334 13.6869 13.334 13.3333V8.66663"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.334 1.66665C12.5992 1.40144 12.9589 1.25244 13.334 1.25244C13.7091 1.25244 14.0688 1.40144 14.334 1.66665C14.5992 1.93187 14.7482 2.29158 14.7482 2.66665C14.7482 3.04173 14.5992 3.40144 14.334 3.66665L8.00065 9.99999L5.33398 10.6667L6.00065 7.99999L12.334 1.66665Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Edit
                            </DropdownItem>
                            <DropdownItem
                               onClick={(e) => {
                                toggleDeleteModal(e, row)
                               }}
                            >
                              <svg
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.20044H2.6H15.4"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M6.59961 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.79883 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Delete
                            </DropdownItem>
                            {/* Toggle Logic */}
                            <DropdownItem onClick={()=>{toggle(row.id, row.shareCode)}}>
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 5.33337C13.1046 5.33337 14 4.43794 14 3.33337C14 2.2288 13.1046 1.33337 12 1.33337C10.8954 1.33337 10 2.2288 10 3.33337C10 4.43794 10.8954 5.33337 12 5.33337Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 14.6666C13.1046 14.6666 14 13.7712 14 12.6666C14 11.5621 13.1046 10.6666 12 10.6666C10.8954 10.6666 10 11.5621 10 12.6666C10 13.7712 10.8954 14.6666 12 14.6666Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.72656 9.00671L10.2799 11.66"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.2732 4.34009L5.72656 6.99342"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Share
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
              )
         },
      },
      // {
      //   name: 'Listing expires on',
      //   cell: row =>{
      //     return(
      //       <span>Aug 24,2021</span>
      //     )
      //    },
      // },
      {
        name: 'Created On',
        cell: row =>{
          return(
             <span>
                {moment(parseInt(row.createdAt)).format("ll")}
             </span>
          )
        },
        selector: 'createdAt',
        sortable: true,
      }
      
    ])
  }, [products, orderby, sortby]);

  const toggle = (productid, shareCode) => {
    setShareUrl(`${process.env.REACT_APP_URL}/product-detail/${productid}`);
    setSharedCode(shareCode);
    toggleShareModal(!shareModal);
  };

  const toggleDeleteModal = (e, product = null) => {
    if (product) {
      setSelectedProduct(product);
    }
    setIsOpenDeleteModal(!isOpenDeleteModal);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    if(value){
      let filteredProducts = _products.filter((product) => {
        return (
          product.name.toLowerCase().includes(value.toLowerCase()) ||
          product.categoryName.toLowerCase().includes(value.toLowerCase()) ||
          product.subCategoryName.toLowerCase().includes(value.toLowerCase())  
        );
      });
      setProducts(filteredProducts);
    }else{
      let filteredProducts = products.sort(sortArrayOfObjects(orderby, sortby));
      setProducts([...filteredProducts]);
    }
    
  };

  const handleSelect = (e, idx) => {};

  const sortByLatest = () => {
    setSortby("desc");
    let filteredProducts = _products.sort(sortArrayOfObjects(orderby, sortby));
    setProducts([...filteredProducts]);
  }

  const sortByOldest = () => {
    setSortby("asc");
    let filteredProducts = _products.sort(sortArrayOfObjects(orderby, sortby));
    setProducts([...filteredProducts]);
  }

   /*Pagination Functions Start*/
   function goToNextPage() {
      setCurrentPage((page) => page + 1);
      setPage(_products.length);
   }

   function goToPreviousPage() {
      setCurrentPage((page) => page - 1);
   }

   function changePage(event) {
      const pageNumber = Number(event.target.textContent);
      setCurrentPage(pageNumber);
   }

   const getPaginatedData = () => {
    const startIndex = currentPage * dataLimit - dataLimit;
    const endIndex = startIndex + dataLimit;
    return _products.slice(startIndex, endIndex);
   };

   const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
    return new Array(pageLimit).fill().map((_, idx) => start + idx + 1);
   };
   /**Pagination function ends*/

   const onListingSelect = state => {
    //console.log("State", state);
    if(state.selectedCount >0 ){
      setIsChecked(true);
      setCheckedProduct(state.selectedRows);
    }else{
      setIsChecked(false);
    }
  }

  const deleteAllProduct = () => {
    var result = window.confirm("Are you sure you want to delete?");
    if (result) {
        for(let i=0; i<allcheckedproduct.length; i++){
            let id = allcheckedproduct[i].id
            dispatch(deleteProduct({id,callback:()=>{}}));
        }
    }
  }

  return (
    <div className="mainContentWrapper">
      <div className="dashContentHeader">
        <h5 className="dashHeading mb-0">My Listing</h5>
      </div>
      <div className="dashboardCardRow producttbl newtbl">
        <div className="input-group mb-4 search-menu">
          <input
            type="text"
            className="form-control"
            placeholder="Search listing..."
            onChange={(e) => handleChange(e)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
            <svg width="17" height="17" fill="none"><circle cx="7" cy="7" r="6.3" stroke="#FF7E06" stroke-width="1.3"/><path d="M12 12l4 4" stroke="#FF7E06" stroke-width="1.3" stroke-linecap="round"/></svg>
            </span>
          </div>
        </div>
        <div className="listingTableRow">
          <div className="listingTableHeader d-flex justify-content-between align-items-center flex-wrap ">
            <div className="custom-control custom-checkbox mb-3">
              {/*<input
                type="checkbox"
                className="custom-control-input"
                id="customCheck1"
              />
              <label className="custom-control-label" for="customCheck1">
                Showing {_products.length} products
              </label>*/}
             </div>
            <div className="d-flex justify-content-between align-items-center">
              {isChecked?(<button 
              onClick={()=>{deleteAllProduct()}}
              className="border-0 deleteButton mr-4 mb-3">
                <svg
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.33398 3.66667V2.33333C3.33398 1.97971 3.47446 1.64057 3.72451 1.39052C3.97456 1.14048 4.3137 1 4.66732 1H7.33398C7.68761 1 8.02674 1.14048 8.27679 1.39052C8.52684 1.64057 8.66732 1.97971 8.66732 2.33333V3.66667M10.6673 3.66667V13C10.6673 13.3536 10.5268 13.6928 10.2768 13.9428C10.0267 14.1929 9.68761 14.3333 9.33398 14.3333H2.66732C2.3137 14.3333 1.97456 14.1929 1.72451 13.9428C1.47446 13.6928 1.33398 13.3536 1.33398 13V3.66667H10.6673Z"
                    stroke="white"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.66602 7V11"
                    stroke="white"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.33398 7V11"
                    stroke="white"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Delete
              </button>):null}
              {/*<div className="d-flex align-items-center shortListedDropdown mb-3">
              
                <div className="dropdown">
                  {" "}
                  <UncontrolledDropdown direction="left" setActiveFromChild>
                    <DropdownToggle
                      tag="a"
                      // className="nav-link dropdown-toggle pl-4"
                    >
                        <label className="mb-0">Sort by</label>
                      <button
                        className="border-0 btn-link dropdown-toggle card-link"
                        type="button"
                        id="dropdownMenu1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                      </button>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={()=>{sortByLatest()}}>Latest</DropdownItem>
                      <DropdownItem onClick={()=>{sortByOldest()}}>Oldest</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>*/}
            </div>
          </div>
          {/*<div className="table-responsive mylisting">
            <table className="table customDashboardTable">
              <thead>
                <tr>
                  <th>Listing Name</th>
                  <th>Category</th>
                  <th>Subcategory</th>
                  <th>Price</th>
                  <th style={{ maxWidth: "100px" }}>Minimum Offer Amount</th>
                  <th style={{ maxWidth: "100px" }}>No. of Offers</th>
                  <th>Status</th>
                  <th>Seller Info</th>
                  <th>Actions</th>
                  <th style={{ maxWidth: "120px", width: '120px' }}>Listing Expires on</th>
                  <th>Created on</th>
                </tr>
              </thead>
              <tbody>
                {getPaginatedData().map((product, index) => (
                  <tr key={index}>
                    <td>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={index}
                          checked={index === isChecked}
                          onChange={(e) => handleSelect(e, index)}
                        />
                        <label
                          className="custom-control-label"
                          for="customCheck2"
                          style={{cursor:"pointer"}}
                          onClick={()=>{ dispatch(push(`/product-detail/${product.id}`));}}
                        >
                          {product.name}
                        </label>
                      </div>
                    </td>
                    <td>{product.categoryName}</td>
                    <td>{product.subCategoryName}</td>
                    <td>${product.buyNowPrice}</td>
                    <td>${product.minimumOfferPrice}</td>
                    <td>${product.offers ? product.offers.length : 0}</td>
                    <td>
                      <button className="btn soldBtn">Sold</button>
                    </td>
                    <td>
                    <span>{product.sellerEmail}</span>
                    </td>
                    <td>
                      <div className="dropdown">
                        <UncontrolledDropdown setActiveFromChild>
                          <DropdownToggle tag="a">
                            <button
                              className="btn btn-link dropdown-toggle"
                              type="button"
                              id="dropdownMenu1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <svg
                                width="22"
                                height="6"
                                viewBox="0 0 22 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                              </svg>
                            </button>
                          </DropdownToggle>
                          <DropdownMenu className="table-action" right>
                            <DropdownItem onClick={(e) => {
                                   e.preventDefault();
                                   dispatch(push(`/add-new/${product.id}`));
                             }}>
                              {" "}
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.33398 2.66663H2.66732C2.3137 2.66663 1.97456 2.8071 1.72451 3.05715C1.47446 3.3072 1.33398 3.64634 1.33398 3.99996V13.3333C1.33398 13.6869 1.47446 14.0261 1.72451 14.2761C1.97456 14.5262 2.3137 14.6666 2.66732 14.6666H12.0007C12.3543 14.6666 12.6934 14.5262 12.9435 14.2761C13.1935 14.0261 13.334 13.6869 13.334 13.3333V8.66663"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.334 1.66665C12.5992 1.40144 12.9589 1.25244 13.334 1.25244C13.7091 1.25244 14.0688 1.40144 14.334 1.66665C14.5992 1.93187 14.7482 2.29158 14.7482 2.66665C14.7482 3.04173 14.5992 3.40144 14.334 3.66665L8.00065 9.99999L5.33398 10.6667L6.00065 7.99999L12.334 1.66665Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Edit
                            </DropdownItem>
                            <DropdownItem
                               onClick={(e) => {
                                toggleDeleteModal(e, product)
                               }}
                            >
                              <svg
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.20044H2.6H15.4"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M6.59961 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.79883 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Delete
                            </DropdownItem>
                            
                            <DropdownItem onClick={()=>{toggle(product.id, product.shareCode)}}>
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 5.33337C13.1046 5.33337 14 4.43794 14 3.33337C14 2.2288 13.1046 1.33337 12 1.33337C10.8954 1.33337 10 2.2288 10 3.33337C10 4.43794 10.8954 5.33337 12 5.33337Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 14.6666C13.1046 14.6666 14 13.7712 14 12.6666C14 11.5621 13.1046 10.6666 12 10.6666C10.8954 10.6666 10 11.5621 10 12.6666C10 13.7712 10.8954 14.6666 12 14.6666Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.72656 9.00671L10.2799 11.66"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.2732 4.34009L5.72656 6.99342"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Share
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </td>
                    <td>Dec 14, 2020</td>
                     <td>{DateTime.fromMillis(Number(product.createdAt)).toFormat(
                         "MMMM dd, yyyy"
                      )}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="tableArrowScrollar">
            <ul className="d-flex align-items-center justify-content-end">
              <li className="mr-4">
                <button className="border-0 btn-link">
                  <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 11H2"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 2L2 11L11 20"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </li>
              <li>
                <button className="border-0 btn-link">
                  <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 11H24"
                      stroke="#FF7E06"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15 2L24 11L15 20"
                      stroke="#FF7E06"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </li>
            </ul>
          </div>*/}
        </div>
       
        {/*<div className="pagination">
            <button
            onClick={goToPreviousPage}
            className={`prev border-0 btn-link ${currentPage === 1 ? 'disabled' : ''}`}
            >
            <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 11H2"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 2L2 11L11 20"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
          </button>
          {getPaginationGroup().map((item, index) => (
              <button
                key={index}
                onClick={changePage}
                className={`paginationItem ${currentPage === item ? 'active' : null}`}
              >
                <span>{item}</span>
              </button>
            ))}
            <button
            onClick={goToNextPage}
            className={`next border-0 btn-link ${currentPage === pages ? 'disabled' : ''}`}
            >
              <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 11H24"
                      stroke="#FF7E06"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15 2L24 11L15 20"
                      stroke="#FF7E06"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
           </button>
          </div>*/}
          {_products && 
            <DataTable
              striped={true}
              highlightOnHover={true}
              pagination={true}
              paginationPerPage={10}
              onRowClicked={productDetail}
              title=""
              columns={columns}
              data={_products}
              selectableRows
              customStyles={customStyles}
              onSelectedRowsChange={onListingSelect}
              paginationIconPrevious={<svg width="32" height="32" fill="none"><path d="M27 16H5M14 7l-9 9 9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
              paginationIconNext={<svg width="32" height="32" fill="none"><path d="M5 16h22M18 7l9 9-9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
          />
          }
        
      </div>
      {shareModal && (
        <Modal isOpen={shareModal} toggle={toggle}>
          <div class="modal-body p-4">
            {/* <h4 class="font-18 w-100 text-center mt-3">
              <b>CODE</b>
            </h4>
            <div className="code">
              <h4>{shareCode}</h4>
              <CopyToClipboard  
                    text={shareCode}
                    onCopy={() => {
                        toast.success('Copied to clipboard');
                    }}
              >
                    <p style={{cursor:"pointer"}} class="mb-0"> Click to copy</p>
              </CopyToClipboard>
            </div> */}
            {/*<div class="share-social d-flex justify-content-center align-items-center mt-3 mb-4">
              <p class="mb-0 mr-4">Share code via: </p>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5 0H2.5C1.12125 0 0 1.12125 0 2.5V17.5C0 18.8787 1.12125 20 2.5 20H17.5C18.8787 20 20 18.8787 20 17.5V2.5C20 1.12125 18.8787 0 17.5 0Z"
                    fill="#1976D2"
                  />
                  <path
                    d="M16.875 10H13.75V7.5C13.75 6.81 14.31 6.875 15 6.875H16.25V3.75H13.75C11.6788 3.75 10 5.42875 10 7.5V10H7.5V13.125H10V20H13.75V13.125H15.625L16.875 10Z"
                    fill="#FAFAFA"
                  />
                </svg>
              </span>
              <span class="mx-3">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M20.625 1.49694C22.3539 3.29269 22 5.20027 22 10.9954C22 15.8079 22.8397 20.6324 18.4452 21.7681C17.0729 22.121 4.91427 22.121 3.54385 21.7663C1.71419 21.2942 0.225521 19.8101 0.0220203 17.2224C-0.00639534 16.8612 -0.00639534 5.13611 0.0229378 4.76761C0.239271 2.01119 1.93602 0.422606 4.17177 0.100856C4.68419 0.0266055 4.78685 0.00460552 7.41585 2.21804e-05C16.7411 0.00460552 18.7853 -0.410645 20.625 1.49694Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      d="M11.0019 2.87893C14.3303 2.87893 17.491 2.58285 18.6983 5.68118C19.1969 6.96085 19.1245 8.62277 19.1245 11.0024C19.1245 13.0906 19.1914 15.0532 18.6983 16.3228C17.4938 19.4229 14.3074 19.1259 11.0038 19.1259C7.81651 19.1259 4.53025 19.4578 3.30834 16.3228C2.80875 15.0303 2.88209 13.3931 2.88209 11.0024C2.88209 7.82893 2.70701 5.78018 4.24609 4.24202C5.80442 2.68368 7.91184 2.87893 11.0056 2.87893H11.0019ZM11.7298 4.34285C4.78692 4.33185 3.90326 3.56002 4.39092 14.2823C4.56417 18.0745 7.45167 17.6584 11.001 17.6584C17.4727 17.6584 17.6588 17.4732 17.6588 10.9988C17.6588 4.44918 17.1454 4.34652 11.7298 4.34102V4.34285ZM6.66609 5.69127C7.20417 5.69127 7.64051 6.1276 7.64051 6.66568C7.64051 7.20377 7.20417 7.6401 6.66609 7.6401C6.12801 7.6401 5.69167 7.20377 5.69167 6.66568C5.69167 6.1276 6.12801 5.69127 6.66609 5.69127ZM11.0019 6.83068C13.3055 6.83068 15.1728 8.69885 15.1728 11.0024C15.1728 13.306 13.3055 15.1733 11.0019 15.1733C8.69834 15.1733 6.83201 13.306 6.83201 11.0024C6.83201 8.69885 8.69834 6.83068 11.0019 6.83068ZM11.0019 8.2946C7.42234 8.2946 7.41776 13.7103 11.0019 13.7103C14.5806 13.7103 14.5861 8.2946 11.0019 8.2946Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="20.5828"
                      y1="20.5949"
                      x2="0.136165"
                      y2="2.8985"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFDD55" />
                      <stop offset="0.5" stop-color="#FF543E" />
                      <stop offset="1" stop-color="#C837AB" />
                    </linearGradient>
                    <clipPath id="clip0">
                      <rect
                        width="22"
                        height="22"
                        fill="white"
                        transform="matrix(-1 0 0 1 22 0)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 0H5C2.23858 0 0 2.23858 0 5V17C0 19.7614 2.23858 22 5 22H17C19.7614 22 22 19.7614 22 17V5C22 2.23858 19.7614 0 17 0Z"
                    fill="#1BD741"
                  />
                  <path
                    d="M3.30664 18.7006L4.38426 14.8732C3.69129 13.696 3.32643 12.3565 3.32643 10.9805C3.32643 6.74374 6.7733 3.29688 11.0101 3.29688C15.2469 3.29688 18.6937 6.74374 18.6937 10.9805C18.6937 15.2173 15.2469 18.6642 11.0101 18.6642C9.68992 18.6642 8.39724 18.3262 7.25368 17.6846L3.30664 18.7006ZM7.45546 16.2867L7.69065 16.4303C8.68771 17.039 9.83557 17.3608 11.0101 17.3608C14.5281 17.3608 17.3903 14.4986 17.3903 10.9805C17.3903 7.46245 14.5281 4.60028 11.0101 4.60028C7.492 4.60028 4.62983 7.46245 4.62983 10.9805C4.62983 12.2063 4.97823 13.3967 5.63727 14.423L5.79565 14.6696L5.17509 16.8737L7.45546 16.2867Z"
                    fill="white"
                  />
                  <path
                    d="M8.85157 7.40308L8.353 7.3759C8.1964 7.36736 8.04279 7.41969 7.92442 7.52251C7.68271 7.73241 7.29623 8.1382 7.17753 8.66699C7.0005 9.45546 7.27407 10.4209 7.98211 11.3864C8.69015 12.3519 10.0096 13.8967 12.3429 14.5564C13.0947 14.769 13.6862 14.6257 14.1425 14.3338C14.5039 14.1026 14.7531 13.7315 14.8429 13.312L14.9225 12.9402C14.9478 12.822 14.8878 12.7021 14.778 12.6515L13.093 11.8749C12.9836 11.8245 12.8539 11.8563 12.7803 11.9517L12.1188 12.8092C12.0688 12.874 11.9833 12.8997 11.9061 12.8725C11.4531 12.7133 9.93562 12.0778 9.10299 10.4739C9.06688 10.4044 9.07586 10.3199 9.12707 10.2606L9.75927 9.52927C9.82386 9.45459 9.84018 9.34959 9.80137 9.25883L9.07504 7.55954C9.03637 7.46907 8.94972 7.40844 8.85157 7.40308Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>*/}
            <hr />
            <div class="share-link mt-3 mb-4">
              <p>Share Link</p>
              <form class="link-text">
                <input
                  type="text"
                  readOnly={true}
                  value={shareUrl}
                />
                <CopyToClipboard  
                    text={shareUrl}
                    onCopy={() => {
                        toast.success('Copied to clipboard');
                    }}
              >
                    <button type="button">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11H14.38L14.06 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z"
                            fill="white"
                          />
                        </svg>
                     </button>
                </CopyToClipboard>
                
              </form>
            </div>
          </div>{" "}
        </Modal>
      )}
      {isOpenDeleteModal && (
        <DeleteModal
          isOpen={isOpenDeleteModal}
          toggle={toggleDeleteModal}
          id={selectedProduct.id}
          method={deleteProduct}
          content={`Are you sure you want to delete '${selectedProduct.name}' sub category?`}
        />
      )}
    </div>
  );
}

export default Products;
